(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($, Drupal) {
  Drupal.behaviors.usda = {
    attach: function attach(context, settings) {
      // *************************************
      // Set variable 'isMobile' for if mobile
      // *************************************
      var isMobile = false; //initiate as false
      // device detection

      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        isMobile = true;
      } // *************************************


      $('.view-blog-category-carousel .view-content, .view-multi-select-blog-category-carousel .view-content').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        accessibility: true,
        variableWidth: true,
        infinite: false,
        responsive: [{
          breakpoint: 559,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }]
      });
      $('#blog-hero-carousel .field__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        accessibility: true,
        infinite: true,
        responsive: [{
          breakpoint: 559,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }]
      });
      $('#video-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        accessibility: true,
        variableWidth: true,
        centerMode: true,
        centerPadding: '25px',
        infinite: true,
        responsive: [{
          breakpoint: 559,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false
          }
        }]
      });
      $('#blog-stories-carousel').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        accessibility: true,
        infinite: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.08,
            slidesToScroll: 1,
            arrows: false
          }
        }, {
          breakpoint: 559,
          settings: {
            slidesToShow: .76,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: .76,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true
          }
        }]
      }); // Mobile video carousel text and controls

      $(document).ready(function () {
        var slickActive = $('#video-carousel .slick-dots li.slick-active button').attr('aria-label');
        $('#video-carousel').append('<div id="mobile-video-slick"><button class="mobile-vid-prev" aria-label="Previous" type="button" tabindex="0" style="">Previous</button><div class="slide-count">' + slickActive + ' </div><button class="mobile-vid-next" aria-label="Next" type="button" tabindex="0" style="">Next</button></div>');
        $('#video-carousel #mobile-video-slick .mobile-vid-prev').click(function () {
          $('#video-carousel .slick-prev').click();
        });
        $('#video-carousel #mobile-video-slick .mobile-vid-next').click(function () {
          $('#video-carousel .slick-next').click();
        });
        $('#video-carousel').on('afterChange', function (event, slick, direction) {
          var slickActive = $('#video-carousel .slick-dots li.slick-active button').attr('aria-label');
          $('#video-carousel .slide-count').text(slickActive);
        });
        $('.connect-blog-tags .views-row').click(function (evt) {
          $(evt.target).find('a').trigger('click');
        });
        if (isMobile) $('.slick-arrow').hide();
      }); // Appending visible desktop filters to the mobile filter accordion areas (might see if we can do this a better way)

      $('#state-filters').append($('.view-state-mobile-filters').not('.view-id-state_mobile_filters').clone());
      $('#commodity-filters').append($('.view-commodity-mobile-filters').clone());
      $('#producer-filters').append($('.view-producer-mobile-filters').clone()); // Mobile filter slide out and close functionality

      $('#filters-open, #filters-close').click(function () {
        $('body').toggleClass('no-scroll');
        $('#filters-open').toggleClass('active');
        $('#mobile-filters').toggleClass('active');

        if ($('#filters-open').hasClass('active')) {
          $('#mobile-filters').animate({
            'right': '100%',
            'left': '0'
          });
        } else {
          $('#mobile-filters').animate({
            'right': '0',
            'left': '100%'
          });
        }
      }); // Mobile slide out acccodion functionality (open and close)

      $('#mobile-filters .usa-accordion-button').click(function () {
        $(this).toggleClass('active');
        var accID = $(this).attr('aria-controls');

        if ($(this).hasClass('active')) {
          // $(this).attr('aria-expanded','true');
          $('#' + accID).attr('aria-hidden', 'false');
        } else {
          // $(this).attr('aria-expanded','false');
          $('#' + accID).attr('aria-hidden', 'true');
        }
      }); // When selecting the checkbox filters, this checks the corresponding actual blog hidden filters

      $('#visible-filters label').on('click', function () {
        var termID = $(this).attr('for');
        termID = termID.replace('edit-', '');
        $(this).toggleClass('checked');
        var checkboxes = $('input[type=checkbox][value=' + termID + ']'); //The event handler

        checkboxes.on("click", function () {
          //Get the state of the check box you clicked
          var checkedState = this.checked; //Make it the state of all the checkboxes

          checkboxes.each(function () {
            this.checked = checkedState;
          });
        });
      }); // Trigger Submission on checkbox/label click (for desktop only)

      $('#visible-filters .view-commodity-mobile-filters label, #visible-filters .view-producer-mobile-filters label').not('#mobile-filters .view-commodity-mobile-filters label, #mobile-filters .view-producer-mobile-filters label').on('click', function () {
        setTimeout(function () {
          $('.views-exposed-form input[type=submit]').click();
        }, 800);
      }); // Mobile state filter dropdown select and apply filters

      $('#visible-filters .view-state-mobile-filters').not('#mobile-filters .view-state-mobile-filters').change(function () {
        var value = $(this).val();
        $('#inherent-filters select[name=state]').find('option[value="' + value + '"]').prop('selected', true);
        $('.views-exposed-form input[type=submit]').click();
      }); // Click category carousel item and filter blog post. This also adds an 'active' class to carousel item

      $(document).on('click keyup', '.term-slide', function (event) {
        if (event.keyCode && event.keyCode !== 13 && event.keyCode !== 32) return;
        var termid = $(this).data('termid');
        $('input[value="' + termid + '"]').click();
        $(this).toggleClass('active');
        $('.views-exposed-form input[type=submit]').click();
        $(document).ajaxComplete(function () {
          if ($('input[value="' + termid + '"]').is(':checked')) {
            $("[data-termid='" + termid + "']").toggleClass('active');
          }
        });
      }); // When mobile 'Apply Filters' button is clicked, do this stuff...

      $('#apply-filters').click(function () {
        // Find hidden filters state dropdown and select the correcct state
        $('#mobile-filters select').each(function () {
          var value = $(this).val();
          $('.views-exposed-form select[name=state]').find('option[value="' + value + '"]').prop('selected', true);
        }); // All all filters to be set and then click the submit button after Apply Button is clicked

        setTimeout(function () {
          $('.views-exposed-form input[type=submit]').click();
        }, 800);
      }); // After Ajax runs, look to see what filters are selected and check the mobile filters

      $(document).ajaxComplete(function () {
        $('body').removeClass('no-scroll');
        $('#mobile-filters .view-state-mobile-filters').val($('#inherent-filters select[name=state]').val());
        $('.view-state-mobile-filters').val($('#inherent-filters select[name=state]').val());
        var filters = [];
        $.each($('.views-exposed-form input[type=checkbox]:checked'), function () {
          filters.push($(this).val());
        });
        var i;

        for (i = 0; i < filters.length; ++i) {
          if ($('input[value="' + filters[i] + '"]').is(':checked')) {
            $('#visible-filters input[type=checkbox][value="' + filters[i] + '"]').attr('checked', 'true');
            $('.view-multi-select-blog-category-carousel .term-slide[data-termid="' + filters[i] + '"]').addClass('active');
          }
        } // add tabindex


        $.each($('.term-slide'), function () {
          $(this).attr('tabindex', '0');
        });
      }); // If tid param is in the URL, run this code

      if (window.location.href.indexOf('?term=') > -1) {
        var myParam = location.search.split('term=')[1];
        $("[data-termid='" + myParam + "']").toggleClass('active');

        window.onload = function () {
          $("[data-termid='" + myParam + "']").click();
          $(document).ajaxComplete(function () {
            if ($('input[value="' + myParam + '"]').is(':checked')) {
              $("[data-termid='" + myParam + "']").toggleClass('active');
            }
          });
        };
      } // If you're coming from another page with the category carousel on it, this removes the tid
      // from the URL so that youcan deselect the category from the filters


      $(".active[data-termid='" + myParam + "']").on('click', function (e) {
        $(this).removeClass('active');
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '';
        window.history.pushState({
          path: newurl
        }, '', newurl);
      }); // If you're coming from another page with the category carousel on it, this removes the tid
      // from the URL so that youcan deselect the category from the filters

      $(".active[data-termid='" + myParam + "']").on('click', function (e) {
        $(this).removeClass('active');
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '';
        window.history.pushState({
          path: newurl
        }, '', newurl);
      }); // adding aria-labels to blog comments

      $('.comment-blog-comment-form').find('#edit-name').attr('aria-label', 'Enter Your Name');
      $('.comment-blog-comment-form').find('#edit-field-formatted-comment-0-value').attr('aria-label', 'Enter Your Response Here');
      $('h4.tab-title').keydown(function (evt) {
        if (evt.key == " ") {
          $(evt.target).trigger('click');
        }
      });

      if (!!$('#post-count').length) {
        var tag_post_count = $('#post-count').text();
        var title_text = $('#block-farmers-page-title ').clone();
        var title_prefix = $('.title-prefix').clone();
        title_text.append(tag_post_count);
        title_text.prepend(title_prefix);
        $('.view-header').html(title_text);
      } // Carousel hack for tag view page


      if (!!$('.connect-blog-tags').length) {
        $('.block.block-views.block-views-blockblog-category-carousel-block-1').find('h2').text('Explore Categories');
        $('.block.block-views.block-views-blockblog-category-carousel-block-1 .view-footer').find('a').hide();

        if (isMobile) {
          $('button.slick-arrow').hide();
          $('#term-carousel').parent().css('zoom', '.8');
          $('#term-carousel').find('.slick-slide').css('margin-right', '1rem');
        }
      } // ===========================


      $(document).on('click', "ul[data-drupal-views-infinite-scroll-pager]", function (evt) {
        if (!!$(this).find('li.pager__item').length) {
          $(this).find('.button').click();
        }
      }); // ===========================

      $(document).ajaxSuccess(function (evt) {
        $('.overlay-throbber').remove();
      });
      $(document).ajaxStart(function (evt) {
        if (!!$('li.pager__item').length) {
          $('.overlay-throbber').remove();
          var overlay = $('<div>').addClass('overlay-throbber');
          var throbber = $('<object>').attr('data', '/themes/farmers/assets/img/flower-throbber.svg');
          overlay.append(throbber);
          $('body').append(overlay);
        } else {
          $(evt.target.forms).map(function (ind, form) {
            if ($(form).attr('data-drupal-selector') == 'views-exposed-form-blog-post-connect-blog') {
              $('.overlay-throbber').remove();
              var overlay = $('<div>').addClass('overlay-throbber');
              var throbber = $('<object>').attr('data', '/themes/farmers/assets/img/flower-throbber.svg');
              overlay.append(throbber);
              $('body').append(overlay);
            }
          });
        }
      }); // This is for removing the right arrow on category carousel on mobile

      if (isMobile) {
        $('.view-blog-category-carousel').find('.slick-arrow.slick-next').hide();
      }

      $('.blog-teaser').click(function () {
        $(this).find('a')[0].click();
      }); // Everything below this belongs to the Drupal behaviors post new JS above this
    }
  };
})(jQuery, Drupal);

},{}]},{},[1]);
